var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcRouter = function SvgIcRouter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic-router_svg__ic-router",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0,0H32V32H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    d: "M23.933,4.867,25,3.8a9.337,9.337,0,0,0-13.333,0l1.067,1.067a8.338,8.338,0,0,1,5.6-2.267,8.338,8.338,0,0,1,5.6,2.267Zm-1.2,1.067a6.119,6.119,0,0,0-8.8,0L15,7a4.833,4.833,0,0,1,6.667,0Zm3.6,9.733H19.667V9H17v6.667H-.333A2.675,2.675,0,0,0-3,18.333v8A2.675,2.675,0,0,0-.333,29H26.333A2.675,2.675,0,0,0,29,26.333v-8A2.675,2.675,0,0,0,26.333,15.667Zm-22.667,8H1V21H3.667Zm4.667,0H5.667V21H8.333Zm4.667,0H10.333V21H13Z",
    transform: "translate(3 -1)"
  })));
};
export default SvgIcRouter;